import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfGroupSchema = withDefaults({
  type: 'pslf-group',
  fields: [
    {
      kind: 'attribute',
      name: 'approverEmail',
    },
    {
      kind: 'attribute',
      name: 'approverName',
    },
    {
      kind: 'attribute',
      name: 'approverPhoneNumber',
    },
    {
      kind: 'attribute',
      name: 'approverTitle',
    },
    {
      kind: 'attribute',
      name: 'approverVerifyWithEmail',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'createdOn',
    },
    {
      kind: 'attribute',
      name: 'deletedAt',
    },
    {
      kind: 'attribute',
      name: 'employerAddressLine1',
    },
    {
      kind: 'attribute',
      name: 'employerAddressLine2',
    },
    {
      kind: 'attribute',
      name: 'employerCity',
    },
    {
      kind: 'attribute',
      name: 'employerCommonName',
    },
    {
      kind: 'attribute',
      name: 'employerFein',
    },
    {
      kind: 'attribute',
      name: 'employerIsGovernment',
    },
    {
      kind: 'attribute',
      name: 'employerIsNotForProfit',
    },
    {
      kind: 'attribute',
      name: 'employerIsPolitical',
    },
    {
      kind: 'attribute',
      name: 'employerIsTaxExempt',
    },
    {
      kind: 'attribute',
      name: 'employerLegalName',
    },
    {
      kind: 'attribute',
      name: 'employerPostalCode',
    },
    {
      kind: 'attribute',
      name: 'employerServices',
    },
    {
      kind: 'attribute',
      name: 'employerState',
    },
    {
      kind: 'attribute',
      name: 'employerWebsite',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'legacyId',
    },
    {
      kind: 'attribute',
      name: 'autoSign',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfForms',
      type: 'pslf-form',
      options: {
        async: false,
        inverse: 'pslfGroup',
      },
    },
    {
      kind: 'belongsTo',
      name: 'autoApproverProfile',
      type: 'pslf-profile',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PslfGroupSchema;
